import * as Cookies from 'es-cookie';
import { isValidLocaleFormat, replaceLanguageInPathname } from '../Global/utils/helpers';

const MLP_PREFERRED_LANG_COOKIE = 'preferredLangMlp';

export function handleRedirect(url) {
    window.location.replace(url);
}

/**
 * Retrieves the user's primary browser language.  If the language is a lang-region string only return the lang.
 */
export function getBrowserLanguage() {
    const browserLanguage = (
        navigator.languages && navigator.languages[0]
        || navigator.language
        || navigator.userLanguage
        || '')
        .toLowerCase();

    return browserLanguage.split('-')[0];
}

/**
 * If the user enters a URL with a language-region string that does not match there current location it will redirect
 * the user to the same url but for the default language for the correct region.
 *
 * @example https://disneyplus.com/es-us/welcome will redirecet to https://disneyplus.com/en/welcome
 */

export function redirectForRegionLang() {
    const regionConfig = window.dssMlpConfigs.regionConfig;
    const { bypassRedirect, regionCode } = regionConfig;

    const redirectSettings = {
        url: null,
        default: null
    };

    let browserRegionLang = null;

    if (!bypassRedirect) {
        let preferredLangMlp = Cookies.get(MLP_PREFERRED_LANG_COOKIE);
        if (preferredLangMlp) {
            preferredLangMlp = preferredLangMlp.toLowerCase();
        }

        const browserLanguage = getBrowserLanguage();

        if (browserLanguage) {
            browserRegionLang = (browserLanguage === regionCode.toLowerCase()) ? browserLanguage : `${browserLanguage}-${regionCode.toLowerCase()}`;
        }

        let langOverride;

        redirectSettings.default = regionConfig.lang;

        const splitUrl = window.location.pathname.split('/');

        const reqUrlPrefix = splitUrl[1];
        let lang;
        if (isValidLocaleFormat(reqUrlPrefix)) {
            lang = reqUrlPrefix.toLowerCase();
        } else {
            lang = 'en';
        }

        if (lang === 'en') {
            //Check to see if User came to domain.com/welcome/xxx
            if (preferredLangMlp && regionConfig.regionLanguages.includes(preferredLangMlp)) {
                //Check to see if preferredLangMLP is set and valid for the current region
                langOverride = (preferredLangMlp !== lang) ? preferredLangMlp : false;
            } else if (browserRegionLang && browserRegionLang !== lang && regionConfig.regionLanguages.includes(browserRegionLang)) {
                //If no preferred Lang set, check the Browser Language
                langOverride = browserRegionLang;
            } else if (lang !== redirectSettings.default) {
                //If no preferred lang and the browser lang is not valid, use the region default (if the default is not EN)
                langOverride = redirectSettings.default;
            }
        } else if (regionConfig && !regionConfig.regionLanguages.includes(lang)) {
            //If the language specified in the Url is a valid region lang do nothing.
            if (browserRegionLang && browserRegionLang !== lang && regionConfig.regionLanguages.includes(browserRegionLang)) {
                //If the specified lang is not valid for the region try the browser language
                langOverride = browserRegionLang;
            } else {
                //If the specified lang and the browser lang are invalid for region, use the region default.
                langOverride = redirectSettings.default;
            }
        }

        if (langOverride) {
            const { origin, search } = window.location;
            let { pathname } = window.location;
            pathname = replaceLanguageInPathname(pathname, langOverride);
            redirectSettings.url = `${origin}${pathname}${search}`;
        }
    }

    if (redirectSettings.url) {
        console.info('Lang Redirect: ', redirectSettings.url);
        handleRedirect(redirectSettings.url);
    }
}
